import React from "react"

function SearchButtons(props) {
    const buttonText = [
        {
            name: "View The Painting",
            id: 3
        },
        {
            name: "Search The Desk",
            id: 2
        },
        {
            name: "Search The Bookcase",
            id: 1
        },
    ]
    
    const buttons = buttonText.map( button => {
        return (
            <button 
                key={button.id} 
                className="standardButton" 
                onClick={props.handleClick} 
                name={button.name} 
                value={button.id}
            >    
                {button.name}
            </button>
        )
    })
    
    return (
        <div className="searchButtonWrapper imageTextWrapper">
            {buttons}
        </div>
    )
}

export default SearchButtons